export default __webpack_public_path__ + "static/media/21.f715de68.jpg";